import {InternalAxiosRequestConfig} from 'axios';
import {logger} from '../utils/logger';
import {getUser} from '../auth';

const log = logger('axios-interceptors');

const applyHeader = (
  config: InternalAxiosRequestConfig<any>,
  key: string,
  value: string
): InternalAxiosRequestConfig<any> => {
  try {
    config.headers![key] = value;
  } catch (error) {
    log.info(`Unable to apply ${key} header`, error);
  }
  return config;
};

const setAuthHeader = async (config: InternalAxiosRequestConfig<any>) => {
  const user = await getUser();
  if (user) {
    return applyHeader(config, 'Authorization', `Bearer ${user.access_token}`);
  }
  return config;
};

let requestCount = 0;
const preventIEGetCaching = (config: InternalAxiosRequestConfig<any>) => {
  if (/get/gi.test(config.method || '')) {
    if (config.params) {
      config.params['_ts'] = `${+new Date()}_${++requestCount}`;
    } else {
      config.params = {
        _ts: `${+new Date()}_${++requestCount}`,
      };
    }
  }

  return config;
};

export const requestInterceptors = compose(
  preventIEGetCaching,
  setAuthHeader,
);

type composeFn<T> = (x: T) => T | Promise<T>;

function compose<T>(...fns: composeFn<T>[]) {
  return async (x: T | Promise<T>): Promise<T> =>
    fns.reduce((v, f) => (async () => f(await v))(), x);
}